import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";

const SAPHEER_COLOR_2 = "#3D97F7";
const useStyles = makeStyles((theme) => ({
  contractHeading: {
    marginTop: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  word: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",

    color: SAPHEER_COLOR_2,
  },
  subTitle2: {
    fontSize: "0.85rem",
    display: "flex",
    color: "#4e5d78",
  },
}));

interface StepSevenTitleProps {
  existingCompany: boolean;
}

const SignedContractTitle: FC<StepSevenTitleProps & WrappedComponentProps> = (
  props,
) => {
  const classes = useStyles();

  return (
    <Box className={classes.contractHeading}>
      <Box>
        <Typography className={classes.subTitle2}>
          <Box mr={1}>1.</Box>
          <Box textAlign={"left"}>
            <span className={classes.word}>
              <FormattedMessage id="contract.paragraph.word1" />
            </span>
            <FormattedMessage id="contract.paragraph.1" />
            <span className={classes.word}>
              <FormattedMessage id="contract.paragraph.word2" />
            </span>
          </Box>
        </Typography>
        <Typography className={classes.subTitle2}>
          <Box mr={1}>2.</Box>
          <Box textAlign={"left"}>
            <span className={classes.word}>
              <FormattedMessage id="contract.paragraph.word3" />
            </span>
            <FormattedMessage id="contract.paragraph.2" />
          </Box>
        </Typography>
        <Typography className={classes.subTitle2}>
          <Box mr={1}>3.</Box>
          <Box textAlign={"left"}>
            <span className={classes.word}>
              <FormattedMessage id="contract.paragraph.word4" />
            </span>
            <FormattedMessage id="contract.paragraph.3" />
            <span className={classes.word}>
              <FormattedMessage id="contract.paragraph.word5" />
            </span>
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default injectIntl(SignedContractTitle);
